import React, { useState } from 'react';
import { Form, InputGroup, Button } from 'react-bootstrap';
import ReactSelect from 'react-select';
import "../../../assets/scss/search-input.scss";

export class NumberInput extends React.Component {
    constructor() {
        super();
        this.handleNumber = this.handleNumber.bind(this);
        this.decrement = this.decrement.bind(this);
        this.increment = this.increment.bind(this);
        this.getEvent = this.getEvent.bind(this);
    }

    handleNumber(event) {
        const { value } = event.target;
        const exp = (this.props.type === "double") ? /[^0-9.]/g : /[^0-9]/g;
        const onlyNums = value.replace(exp, '').toString();
        if (this.props.onUpdate) this.props.onUpdate(this.getEvent(onlyNums));
    }

    increment() {
        let value = this.props.value;
        if (!value) value = 0;
        const step = this.props.step ? parseFloat(this.props.step) : (this.props.type === "double") ? 0.1 : 1;

        if (value >= 0) {
            const newValue = (this.props.type === "double") ? (Number(value) + step).toFixed(1) : Number(value) + step;
            if (this.props.onUpdate) this.props.onUpdate(this.getEvent(newValue));
        }
    }

    decrement() {
        let value = this.props.value;
        if (!value) value = 0;
        const step = this.props.step ? parseFloat(this.props.step) : (this.props.type === "double") ? 0.1 : 1;

        if (value > 0) {
            const newValue = (this.props.type === "double") ? (Number(value) - step).toFixed(1) : Number(value) - step;
            if (this.props.onUpdate) this.props.onUpdate(this.getEvent(newValue));
        }
    }

    getEvent(value) {
        return { target: { name: this.props.name, value } };
    }

    render() {
        const maxLength = this.props.maxLength ? this.props.maxLength : (this.props.type === "double") ? 5 : 3;
        const inputProps = { ...this.props };
        if (inputProps.onUpdate) delete inputProps.onUpdate;

        return <InputGroup>
            <InputGroup.Append>
                <Button variant="secondary" onClick={this.decrement}>
                    <i className="fa fa-minus" />
                </Button>
            </InputGroup.Append>
            <Form.Control {...inputProps} type="text" onChange={this.handleNumber} autoComplete="off" maxLength={maxLength} />
            <InputGroup.Append>
                <Button variant="secondary" onClick={this.increment}>
                    <i className="fa fa-plus" />
                </Button>
            </InputGroup.Append>
        </InputGroup>;
    }
};

export class Select extends React.Component {
    getSelectedOption() {
        const { value, options } = this.props;
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === value) {
                return options[i];
            } else if (options[i].options) {
                for (let ii = 0; ii < options[i].options.length; ii++) {
                    if (options[i].options[ii].value === value) {
                        return options[i].options[ii];
                    }
                }
            }
        }
        return null;
    }

    render() {
        const { value, inputValue, ...rest } = this.props;

        let selectProps = { isClearable: true, ...rest };

        const unknownOption = { value: -1, label: "Unknown" };

        const sortOptions = (item1, item2, keyName, sortType) => {
            const a = sortType === "asc" ? item1 : item2;
            const b = sortType === "desc" ? item1 : item2;

            if (a[keyName] && b[keyName] && a[keyName].toString().toLowerCase() < b[keyName].toString().toLowerCase()) return -1;
            else if (a[keyName] && b[keyName] && a[keyName].toString().toLowerCase() > b[keyName].toString().toLowerCase()) return 1;
            else return 0;
        };

        const optionsOrder = (options, sortType) => {
            const otherOptions = options
                .filter(item => item.label && item.value)
                .filter(item => item.value !== -1 && item.label.toString().trim().length > 0)

            otherOptions.sort((a, b) => sortOptions(a, b, "label", sortType))
            if (this.props.hasOwnProperty("includeUnknown")) return [unknownOption, ...otherOptions];
            else return [...otherOptions];
        };

        if (this.props.hasOwnProperty("sortType")) selectProps = {
            ...selectProps,
            options: optionsOrder(this.props.options, this.props.sortType)
        };

        if (this.props.hasOwnProperty("disabled")) selectProps = { ...selectProps, isDisabled: this.props.disabled };

        //multiselect 
        if (this.props.isMulti) {
            if (!(this.props.value && this.props.value.length > 0)) selectProps = { ...selectProps, value: [] };
        }
        //singleselect
        else {
            if (this.props.hasOwnProperty("value")) {
                const selectOption = this.getSelectedOption();
                selectProps = { ...selectProps, value: selectOption, inputValue: selectOption ? '' : inputValue };
            }
            else selectProps = { ...selectProps, inputValue }
        }
        // max width style
        selectProps.styles = {
            ...(selectProps.styles || {}),
            menu: (base) => ({
                ...base,
                width: "max-content",
                minWidth: "100%"
            })
        };


        return (<ReactSelect  {...selectProps} />);
    }
};

export const SearchInput = props => {
    const { className, onChange, initialValue = "", placeholder = "Search" } = props;
    const [text, setText] = useState(initialValue);
    const handleText = text => {
        setText(text);
        if (onChange) onChange(text);
    };

    return <div className={`input-search-container ${className || ""}`}>
        <div className="input-with-icon">
            <input
                type="text"
                placeholder={placeholder}
                value={text}
                onChange={e => handleText(e.target.value)}
            />
            {text ?
                <i className="fa fa-times-circle" aria-hidden="true" onClick={() => handleText("")} /> :
                <i className="fa fa-search" aria-hidden="true" />}
        </div>
    </div>;
};

export const SearchTextBox = React.forwardRef((props, ref) => {
    const { placeholder, value, className, onChange, onClear } = props;

    return <div className={`input-search-container ${className || ""}`}>
        <div className="input-with-icon">
            <input
                ref={ref}
                type="text"
                value={value}
                autoComplete="off"
                placeholder={placeholder}
                onChange={onChange}
            />
            {value ?
                <i
                    className="fa fa-times-circle"
                    aria-hidden="true"
                    title="Clear"
                    onClick={e => {
                        if (ref) ref.current.focus();
                        onClear(e);
                    }} /> :
                <i className="fa fa-search" aria-hidden="true" />}
        </div>
    </div>;
});